const toBytes = (size, type) => {
    const types = ['B', 'KB', 'MB', 'GB', 'TB'];

    const key = types.indexOf(type.toUpperCase());

    if (key !== -1) {
        return size * (1024 ** key);
    }

    return 'invalid type: type must be GB/KB/MB etc.';
};

export default toBytes;
